/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { MenuBarLink } from "~/layout/MenuBar/MenuItem";
import { Submenu } from "~/layout/MenuBar/Submenu";
import { ROUTES } from "~/routing/routes";

export function ResourcesSubmenus() {
  return (
    <Submenu>
      <>
        <ul>
          <li>
            <MenuBarLink route={ROUTES.resources.index}>Resources</MenuBarLink>
          </li>
          <li>
            <MenuBarLink route={ROUTES.resources.reports}>Reports</MenuBarLink>
          </li>
        </ul>
      </>
    </Submenu>
  );
}
